import { AGSWin } from "ags/integration/schema/ags-spin-response-schema";
import Record from "slotworks/model/gameplay/records/record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import Result from "slotworks/model/gameplay/records/results/result";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

export abstract class AGSResultBuilder implements ResultBuilder {

    public abstract filter(data: any): boolean;

    public abstract build(record: Record, data: any): Result[];

    protected processFreespinData(record: Record, data: AGSWin, result: Result) {
        const freespinResults = [];
        if (data.freeSpinsAmount > 0) {

            const freespinResult = new FreespinWinResult();
            freespinResult.freespinsWon = data.freeSpinsAmount;
            freespinResults.push(freespinResult);

            result.linkedResult = freespinResult;
            freespinResult.linkedResult = result;
        }

        return freespinResults;
    }
}
